/** Канонический список зон коррекции (чекбоксы / нормализация). */
export const CORRECTION_ZONE_OPTIONS = [
  'Аурикуло-платизмальная связка',
  'Брыли (премалярная зона)',
  'Векторный лифтинг (VE Lift)',
  'Височная зона',
  'Височная мышца',
  'Височная область',
  'Височная область (граница роста волос)',
  'Горизонтальные морщины лба',
  'Губно-краевая борозда',
  'Гусиные лапки (периорбитальная зона)',
  'Губы',
  'DAO (депрессор угла рта)',
  'Декольте',
  'Жевательная мышца',
  'Инфраорбитальная зона',
  'Кисти рук',
  'Кисетные морщины',
  'Корругаторы (межбровные мышцы)',
  'Латеральные отделы лица',
  'Лицо целиком',
  'Лоб',
  'Лоб (фронтальная мышца)',
  'Мандибулярная связка',
  'Мандибулярные связки',
  'Межбровные морщины',
  'Межбровье (корругаторы)',
  'Морщины марионеток',
  'Морщины щек',
  'Надбровные дуги',
  'Нижняя треть лица',
  'Нос',
  'Носогубная складка',
  'Носогубный треугольник',
  'Околоушно-жевательная зона',
  'Основание козелка',
  'Периоральная зона',
  'Периорбитальная зона',
  'Периорбитальная зона (гусиные лапки)',
  'Платизма шеи',
  'Платизмальная и преаурикулярная связки',
  'Подбородок',
  'Подбородочная область',
  'Подподбородочная зона / Максиллярные псевдосвязки',
  'Подподбородочная складка',
  'Преаурикулярная область',
  'Проекция нижнечелюстной связки',
  'Проекция скуловой дуги',
  'Проекция скуловой связки',
  'Проекция угла нижней челюсти',
  'Процерус',
  'Скуловая дуга',
  'Скуловая область',
  'Скулы',
  'Точка «уставшего лица»',
  'Угол рта',
  'Угол нижней челюсти',
  'Шея',
];

const DELETE_ZONES = new Set([
  '05 мл)',
  'височная область (микроболюс 0',
  'интимные зоны',
  'beauty flash',
]);

const RENAME_MAP = {
  'аурикуло-платизмальная связка': 'Аурикуло-платизмальная связка',
  'височная зона (межфасциальное пространство)': 'Височная зона',
  'височная мышца.': 'Височная мышца',
  'височная мышца': 'Височная мышца',
  'височная область': 'Височная область',
  'височную область': 'Височная область',
  'вся зона лица': 'Лицо целиком',
  'fullface': 'Лицо целиком',
  'горизонтальные морщины лба (лобная мышца)': 'Горизонтальные морщины лба',
  'губно-краевая борозда': 'Губно-краевая борозда',
  'губы': 'Губы',
  'декольте': 'Декольте',
  'зона брылей': 'Брыли (премалярная зона)',
  'зона жевательной мышцы (микроболюсы в шахматном порядке)': 'Жевательная мышца',
  'зона кисетных морщин (под углом рта).': 'Кисетные морщины',
  'зона кисетных морщин (под углом рта)': 'Кисетные морщины',
  'зона марионеток': 'Морщины марионеток',
  'зона прикрепления платизмальной и преаурикулярной связок (три точки: угол нижней челюсти': 'Платизмальная и преаурикулярная связки',
  'инфраорбитальная зона (полулунным краем орбиты)': 'Инфраорбитальная зона',
  'кисти рук': 'Кисти рук',
  'корругаторы)': 'Корругаторы (межбровные мышцы)',
  'корругаторы': 'Корругаторы (межбровные мышцы)',
  'латеральные морщины («гусиные лапки») — круговая мышца глаза': 'Гусиные лапки (периорбитальная зона)',
  'латеральные отделы лица (для лифтинга)': 'Латеральные отделы лица',
  'лоб': 'Лоб',
  'лоб (фронталис)': 'Лоб (фронтальная мышца)',
  'мандибулярная связка': 'Мандибулярная связка',
  'мандибулярные связки (зона морщин марионеток)': 'Мандибулярные связки',
  'массетер (жевательная мышца)': 'Жевательная мышца',
  'межбровные морщины (процерус': 'Межбровные морщины',
  'межбровье': 'Межбровье (корругаторы)',
  'межбровье (корругатор': 'Межбровье (корругаторы)',
  'межбровье': 'Межбровье (корругаторы)',
  'морщины в области щек': 'Морщины щек',
  'надбровные дуги (по 0.05 мл)': 'Надбровные дуги',
  'нижняя треть лица': 'Нижняя треть лица',
  'нос': 'Нос',
  'носогубная складка': 'Носогубная складка',
  'носогубный треугольник': 'Носогубный треугольник',
  'область глаз (dao – подъём бровей)': 'DAO (депрессор угла рта)',
  'околоушная область (преаурикулярная зона)': 'Преаурикулярная область',
  'околоушно-жевательная зона': 'Околоушно-жевательная зона',
  'основание козелка верхнее и нижнее)': 'Основание козелка',
  'периоральную зону': 'Периоральная зона',
  'периорбитальная зона': 'Периорбитальная зона',
  'периорбитальная зона (лучики «гусиных лапок»)': 'Периорбитальная зона (гусиные лапки)',
  'платизма шеи': 'Платизма шеи',
  'подбородок': 'Подбородок',
  'подбородочная область': 'Подбородочная область',
  'подподбородочная зона и зона «морщины повторения улыбки» (псевдосвязки максиллярной области)': 'Подподбородочная зона / Максиллярные псевдосвязки',
  'подподбородочная складка': 'Подподбородочная складка',
  'преаурикулярная область': 'Преаурикулярная область',
  'проекция нижнечелюстной связки': 'Проекция нижнечелюстной связки',
  'проекция скуловой дуги (до 0.2 мл)': 'Проекция скуловой дуги',
  'проекция скуловой связки': 'Проекция скуловой связки',
  'проекция угла нижней челюсти': 'Проекция угла нижней челюсти',
  'процерус)': 'Процерус',
  'процерус': 'Процерус',
  'скуловая дуга': 'Скуловая дуга',
  'скуловая область': 'Скуловая область',
  'скулы': 'Скулы',
  'точка «уставшего лица» (под горизонтальной линией)': 'Точка «уставшего лица»',
  'угл рта': 'Угол рта',
  'угол рта': 'Угол рта',
  'угол нижней челюсти': 'Угол нижней челюсти',
  'шея': 'Шея',
  've lift': 'Векторный лифтинг (VE Lift)',
};

export const normalizeCorrectionZoneToken = (s) =>
  String(s || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const normalizeKey = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9а-яё]/gi, '')
    .trim();

/** Приводит произвольную строку из БД к каноническому названию */
export const canonicalCorrectionZone = (token) => {
  const raw = String(token || '').trim();
  if (!raw) return null;
  if (DELETE_ZONES.has(raw.toLowerCase())) return null;

  const renamed = RENAME_MAP[raw] || RENAME_MAP[raw.toLowerCase()];
  if (renamed) return renamed;

  const exact = CORRECTION_ZONE_OPTIONS.find(
    (opt) => normalizeCorrectionZoneToken(opt) === normalizeCorrectionZoneToken(raw)
  );
  if (exact) return exact;

  const key = normalizeKey(raw);
  const byKey = CORRECTION_ZONE_OPTIONS.find((opt) => normalizeKey(opt) === key);
  if (byKey) return byKey;

  return null;
};

export function parseCorrectionZonesFromString(str) {
  if (!str || !String(str).trim()) return [];
  const parts = String(str)
    .split(/[,;\n]+/)
    .map((t) => t.trim())
    .filter(Boolean);
  const out = [];
  const seen = new Set();
  parts.forEach((p) => {
    const c = canonicalCorrectionZone(p);
    if (c && !seen.has(c)) {
      seen.add(c);
      out.push(c);
    }
  });
  return out;
}

export function joinCorrectionZones(arr) {
  return (arr || []).filter(Boolean).join(', ');
}
